import { browser } from '$app/environment';

export const gtmDispatch = (data: any): void => {
	if (browser && window.dataLayer) {
		window.dataLayer.push(data);
	}
};
